import React from "react";
import Head from "next/head";
import { useTranslation } from "react-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import ContactRoot from "../src/views/contact";

const ContactUs = () => {
  const { t } = useTranslation(["contact"]);
  return (
    <React.Fragment>
      <Head>
        <title>{t("contact:metaTitle")}</title>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </Head>
      <ContactRoot />
    </React.Fragment>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      "common",
      "contact",
      "footer",
      "header",
    ])),
  },
});

export default ContactUs;
